export const TIME_FORMAT_LUXON = 'h:mm a';
export const DATE_FORMAT_LUXON = 'cccc, LLLL d, yyyy'; 
export const DATE_TIME_FORMAT_LUXON = 'cccc, LLLL d, yyyy, h:mm a';

export const ROLE_SITE_ADMIN = 'SiteAdmin';
export const ROLE_COMMUNITY_ADMIN = 'CommunityAdmin';
export const ROLE_FAMILY_MEMBER = 'FamilyMember';
export const ROLE_COMMUNITY_MEMBER = 'CommunityMember';
export const ROLE_PROGRAM_DIRECTOR = 'ProgramDirector';
export const ROLE_INSTRUCTOR = 'Instructor';

export const DEFAULT_VOLUME = 50;

export const EVENT_VIDEO = "Video";
export const EVENT_TEXT_EVENT = "TextEvent";
export const EVENT_BINGO = "BingoEvent";
export const EVENT_JITSI = "JitsiEvent";
export const EVENT_NAMES = {
  Video: 'Video',
  BingoEvent: 'Bingo',
  JitsiEvent: 'Video Conference',
  TextEvent: 'Reminder'
};

export const ATTR_PLAY_IMMEDIATELY = "PLAY_IMMEDIATELY";

export const EVENT_NOT_READY = 0;
export const EVENT_ABOUT_TO_START = 1;
export const EVENT_STOPPED = 2;
export const EVENT_STARTED = 3;
export const EVENT_CANCELLED = 4;
export const EVENT_SHOW_URL = 5;

export const USER_MUTED = 6;
export const USER_UNMUTED = 7;

export const EVENT_BINGO_GAME = 8;
export const EVENT_BINGO_BALL = 9;

export const EVENT_TELECON_STARTED = 10;

export const EVENT_STATUS_TEXT = ['NOT READY', 'ABOUT TO START', 'STOPPED', 'STARTED', 'CANCELLED', 
  'SHOW_URL', 'MUTED', 'UNMUTED', 'BINGO GAME', 'BINGO BALL', 'TELECON STARTED'];

export const PRE_START_MINUTES = 2;
export const MAX_EVENT_MINUTES = 180;
export const MS_MINUTE = 60 * 1000;
export const MS_HOUR = 60 * MS_MINUTE;
export const MS_DAY = 24 * MS_HOUR;

//export const WEBSOCKET_URL = "wss://villageradiotest.org/itvs-site/";
export const WEBSOCKET_URL = "wss://villageradio.org/itvs-site/";
